const AppleIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="11"
            height="12"
            viewBox="0 0 11 12"
            fill="none"
        >
            <path
                d="M7.26263 1.92312C7.67653 1.40543 7.9574 0.710318 7.88332 0C7.27744 0.0301271 6.53807 0.399722 6.11002 0.91782C5.72567 1.36149 5.38549 2.0857 5.47417 2.76624C6.15431 2.82524 6.83381 2.42628 7.26263 1.92312Z"
                fill="#0F172A"
            />
            <path
                d="M7.87556 2.89908C6.88784 2.84025 6.04804 3.45966 5.57635 3.45966C5.1044 3.45966 4.3821 2.92873 3.60086 2.94304C2.58404 2.95798 1.64054 3.5329 1.12455 4.44729C0.0632326 6.27653 0.844467 8.98993 1.87654 10.4797C2.37774 11.2168 2.98177 12.0283 3.77767 11.9992C4.52966 11.9697 4.82441 11.5123 5.73849 11.5123C6.65189 11.5123 6.9174 11.9992 7.71343 11.9844C8.53893 11.9697 9.05502 11.247 9.55621 10.5092C10.1312 9.66904 10.3665 8.85775 10.3814 8.81322C10.3665 8.79846 8.78955 8.19349 8.77493 6.37946C8.76004 4.86054 10.013 4.13806 10.072 4.09325C9.36443 3.04673 8.25885 2.92873 7.87556 2.89908Z"
                fill="#0F172A"
            />
        </svg>
    );
};

export default AppleIcon;
